import { AmenitySvg, AmenitySvgProps } from "./AmenitySvg";

export function WesternToiletIcon(props: AmenitySvgProps) {
  return (
    <AmenitySvg {...props}>
      <path
        d="M17.4004 17C18.3717 16.0878 19 14.6356 19 13C19 10.2386 17.2091 8 15 8C12.7909 8 11 10.2386 11 13C11 14.6356 11.6283 16.0878 12.5996 17"
        stroke="currentColor"
        strokeWidth={1.5}
      />
      <path
        d="M11.1067 17L18.8933 17C19.479 17 20 17.4143 20 18C20 19.5105 19.3302 21.0905 18.2713 22.1262C17.7465 22.6395 17.2349 23.1721 17.8701 23.8686C17.9657 23.9734 18.0766 24.0645 18.1698 24.1715C18.4978 24.5478 18.1458 25 17.7227 25H12.2773C11.8542 25 11.5022 24.5478 11.8302 24.1715C11.9234 24.0645 12.0343 23.9734 12.1299 23.8686C12.7651 23.1721 12.2535 22.6395 11.7287 22.1262C10.6698 21.0905 10 19.5105 10 18C10 17.4143 10.521 17 11.1067 17Z"
        stroke="currentColor"
        strokeWidth={1.5}
      />
      <path
        d="M21.2893 15C21.8844 15 22.3826 14.5702 22.4418 14.0059L22.8095 10.5018C23.0228 8.46884 23.1294 7.45238 22.7327 6.68365C21.746 4.77184 19.4338 5.00941 17.5944 5.00941L12.4056 5.00941C10.5662 5.00941 8.25402 4.77184 7.26731 6.68365C6.87056 7.45238 6.9772 8.46884 7.1905 10.5018L7.55816 14.0059C7.61737 14.5702 8.11562 15 8.71068 15"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </AmenitySvg>
  );
}
